import { render, staticRenderFns } from "./drawer-collection-minimal.vue?vue&type=template&id=26000ada&"
import script from "./drawer-collection-minimal.vue?vue&type=script&lang=js&"
export * from "./drawer-collection-minimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports